import ReactDOM from 'react-dom/client';
import React from 'react';
import { ActionWidget } from './action-widget';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';

export function initActionWidget() {
  document.getElementsByName('action-widget').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = (mutations: MutationRecord[]) => {
        if (mutations.length === 0) {
          const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;
          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <ActionWidget {...props} />
              </TenantContext.Provider>,
            ),
          );
        }
      };

      bootstrap([]);
    }
  });
}
